// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IClientEndpointFactory {
	$type?: string | undefined;
}
export class ClientEndpointFactory {
	constructor(data?: IClientEndpointFactory) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	static $type: string = "CoreApi.Models.ClientEndpoints.ClientEndpointFactory, ";
	$type?: string | undefined = ClientEndpointFactory.$type;
}

